import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS,
  LoggingService,
  MyTripAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import {
  HTTP_HEADERS,
  MY_TRIPS_IDP_APP,
  MyTripEndpointKeys,
  TIMEOUT
} from '../models/enums/my-trip.enums';
import { PaymentReference } from '../models/interface';
import { CardData } from '../models/interface/my-trip-static.interface';
@Injectable({
  providedIn: 'root'
})
export class MyTripsService {
  timeout!: number;
  errorHandler = this.handleError.bind(this);
  url$ = new BehaviorSubject<string>('');
  myTripsHeader: HttpHeadersPayload = {
    'Content-Type': HTTP_HEADERS.CONTENT_TYPE,
    appId: HTTP_HEADERS.APP_ID,
    channelId: HTTP_HEADERS.CHANNEL_ID,
    purchasePath: HTTP_HEADERS.PURCHASE_PATH
  };

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logging: LoggingService
  ) {
    this.initializeTimeout();
  }

  initializeTimeout(): void {
    this.appConfig
      .getConfigValue(MY_TRIPS_IDP_APP, TIMEOUT)
      .subscribe((value: string) => {
        this.timeout = Number(value);
      });
  }

  getURL = (key: string): void => {
    this.appConfig
      .getConfigValue(MY_TRIPS_IDP_APP, key)
      .subscribe((url) => this.url$.next(url));
  };

  getPageContent = (): Observable<MyTripAem> =>
    new ApiBuilder<string, MyTripAem>(this.http, this.appConfig)
      .app(IDP_APPS.HEADER)
      .endpointKey(MyTripEndpointKeys.MY_TRIPS_STATIC)
      .method(HttpRequestMethods.GET)
      .library(MY_TRIPS_IDP_APP)
      .create()
      .pipe(
        map((response) => response),
        catchError((err) => this.handleError(err)),
        shareReplay()
      );

  getCardReferenceId = (cardNumber: string): Observable<PaymentReference> => {
    const requestData: CardData = {
      cardDetails: {
        paymentCardNum: cardNumber
      }
    };

    return new ApiBuilder<CardData, PaymentReference>(this.http, this.appConfig)
      .app(MY_TRIPS_IDP_APP)
      .endpointKey(MyTripEndpointKeys.PAYMENT_V2)
      .method(HttpRequestMethods.POST)
      .payload(requestData)
      .httpHeaders(this.myTripsHeader)
      .errorHandler(this.handleError.bind(this))
      .timeOut(this.timeout)
      .create()
      .pipe(
        map((response: PaymentReference) => response),
        catchError((err) => this.handleError(err))
      );
  };

  handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
